import React, { useState, useEffect, useRef } from 'react'

import {
  Modal, Button, Dropdown, Form, Popover, Col, OverlayTrigger
} from 'react-bootstrap';

import _ from 'lodash';
import cx from 'classnames';
import LinesEllipsis from 'react-lines-ellipsis';
import { IKImage } from "imagekitio-react";
import dateformat from "dateformat";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpandArrowsAlt } from '@fortawesome/free-solid-svg-icons';

import Tooltip from 'components/Tooltip';

import styles from './componentStyles.module.scss';
import FileService from 'services/file.service';
import Truncate from 'react-truncate';

const defaultContentImage = '/public/cleverstory/v2/static/default_card.jpg';

export const ContentCard = ({ assetData, selected, onSelect, isLocked, key, className }) => {

  const getFieldSelector = (mapping, key) => {
    const fields = _.get(mapping, 'fields') || [];
    const field = fields.find(item => item.name === key);

    return field;
  }
  const [tooltip, setTooltip] = useState(false)

  const getContentForFieldSelector = (mapping, key) => {
    const field = getFieldSelector(mapping, key);

    if (!field) {
      return null;
    }

    return _.get(field, `content`);
  }

  const handleClick = (e) => {
    if (!onSelect) {
      return;
    }

    onSelect(e, assetData.content && assetData.content.id);
  }

  const handleTooltip = (truncated) => {
    setTooltip(truncated);
  }

  var content = _.get(assetData, 'content.asset', '') || _.get(assetData, 'content', '') || _.get(assetData, 'asset', '');
  var entityType = _.get(content, 'entityType', '');

  var name = getContentForFieldSelector(assetData, 'name') || _.get(content, 'name', '');
  var iconData = getContentForFieldSelector(assetData, 'icon') ||  _.get(content, 'icon', '');

  var iconUrl = _.get(iconData, 'url', null) || _.get(iconData, 'key', null);

  return (
    <div key={key} onClick={handleClick} className={cx(styles.assetCardWrapper, className, 'cs-content-card', {
      [styles.selected]: selected
    })}>
      <div className={styles.iconWrapper}>
        <IKImage
          className={styles.icon}
          path={iconUrl || defaultContentImage}
        />
        {/* <div className={styles.overlay}>
          <FontAwesomeIcon className={cx(styles.dragIcon, 'content-drag-icon')} icon={faExpandArrowsAlt} />
        </div> */}
      </div>
      <div className={styles.detailsContainer}>
        {name &&
          <Tooltip placement="top" content={name} disabled={!tooltip} className={styles.tooltip}>
            <span className={styles.name}>
              <Truncate onTruncate={handleTooltip} lines={1}>
                  {name}
              </Truncate>
            </span>
          </Tooltip>
        }
        <ContentMetadata content={content} entityType={entityType} />
      </div>
    </div>
  )
}

export const ContentMetadata = ({ content, entityType, className }) => {

  const metaData = _.get(content, 'metadata') || null;
  let fileMetaData = metaData && FileService.fileMetaData(metaData);

  let storyboardType = _.get(content, 'storyboardType');

  let modifiedDate = metaData ? metaData.modified_date : content.modifiedDate;

  const renderStoryboardType = (type) => {
    if (type === 'LANDING_PAGE') {
      return 'Landing page';
    } else if (type === 'INTERACTIVE_CONTENT') {
      return 'Interactive content';
    } else if (type === 'RESOURCE_CENTER') {
      return 'Resource center';
    }
  }

  return (
    <div className={styles.metaData}>
      <div className={styles.type}>
        {entityType === 'asset' &&
          <>
            <i className={cx(styles.fileIcon, `${FileService.fileIcon(metaData)}`)} />
            <span className={styles.textFormat} >{FileService.fileType(metaData)}</span>
          </>
        }
        {entityType === 'page' &&
          <>
            <i className={cx(styles.fileIcon, `${FileService.storyboardIcon(storyboardType)}`)} />
            <span className={styles.storyboardTextFormat} >{renderStoryboardType(storyboardType)}</span>
          </>
        }
      </div>
      {fileMetaData && <i className={cx(styles.seperator)}></i>}
      {fileMetaData && <span className={styles.contentMetadata}>{fileMetaData}</span>}
      <i className={cx(styles.seperator)}></i>
      <span className={styles.date}>{dateformat(modifiedDate, 'dd mmm yyyy')}</span>
    </div>
  );
}

export const ContentCardPlaceholder = () => {
  return (
    <div className={cx(styles.contentCard, styles.placeholder)}>
      <div className={cx(styles.iconWrapper)}></div>
      <div className={styles.detailsContainer}>
        <div className={styles.name}>
          <span>&nbsp;</span>
          <span>&nbsp;</span>
        </div>
        <div className={cx(styles.contentMetadata)}>
          {_.times(2).map(index => {
            return (
              <div key={index} className={styles.metadata}><span>&nbsp;</span></div>
            );
          })}
        </div>
      </div>
    </div>
  )
}